import styled from 'styled-components';

export const HeaderFormContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerFormPrint = styled.div`
  display: flex;
  flex-direction: row;
`;
